import React, { useEffect, useState } from "react";
import { Form, Input,Spin } from "antd";
import toast from "react-hot-toast";
import { OtpApi, SendOtpApi } from "../../api/request/users";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setUserDetails, setloggedIn } from "../../store/Slices/userSlice";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";


function Otp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const [FormData, setFormData] = useState({ otp: "" });
  const [isLoadingOtp, setIsLoadingotp] = useState(false);

  const formatTime = (timer) => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  useEffect(() => {
    setInterval(() => {
      setTimer(current => current !== 0 ? current - 1 : 0);
    }, 1000);
  }, []);

  const handleSubmit = async () => {
    const { otp } = FormData;
    if (!otp) {
      toast.error("OTP can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        otp: (FormData.otp).toString(),
      }
      const { data } = await OtpApi(params);
      toast.success(data.message)
      localStorage.setItem("token", data.data.token)
      dispatch(setloggedIn(true));
      let user = data?.data;
      delete user?.access_token;
      dispatch(setUserDetails(user));
      navigate("/dashboard");
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };

  const onChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    setFormData({ ...FormData, otp: newValue });
  };

  const sharedProps = {
    onChange,
  };

  const resendOTPHandler = async () => {
    try {
      setIsLoadingotp(true)
      const { data } = await SendOtpApi(localStorage.getItem('userId'));
      if (data?.success) {
        toast.success(data?.message);
        setFormData({ otp: "" })
        setTimer(120);
      }
      setIsLoadingotp(false)
    } catch (err) {
      setIsLoadingotp(false)
     }
  }

  return (
    <>

      <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9]' style={{ backgroundImage: "url('/assets/images/home12.gif')", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
        <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
          <div className="flex justify-center mb-4">

            <img src='/assets/logo/logo.png' alt='logo' className='h-30 w-32 rounded-full object-contain ' />
          </div>
          <div className="text-center">
            <p className="text-[#2F2B3D] text-2xl font-semibold auth-heading">
              Educational Eternity!
            </p>
            <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
              Please enter the OTP and verify yourself
            </p>
          </div>
          <div className="w-full">
            <Form autoComplete="off" onFinish={handleSubmit}>
              <div className="w-full text-sm py-1">
                <div className="relative">
                  <Form.Item
                    name="otp"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input.OTP
                      variant="filled"
                      {...sharedProps}
                      value={FormData.otp}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div>
              {isLoadingOtp ? (
                <div className="flex justify-center flex-col my-[8%]">
                  <Spin size="large" />
                  <p className="primary text-center mt-2">Loading...</p>
                </div>
              ) : (
                <div className="my-6 flex justify-center">
                  {
                  timer == 0 ? (<button onClick={resendOTPHandler} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<p>Resend OTP in {formatTime(timer)}</p>)
                  }
                </div>
              )}
            </div>
              <div className="mt-8">
                <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Verify' isLoading={isLoading} loadingLable='Verifying...' />
              </div>
            </Form>
            <div className="primary flex items-center justify-center mt-5 text-sm">
                <a href="/login" className="">Back to login</a>
              </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Otp;



